<section class="select-country" [class]="customClasses">

  <div class="dropdown-toggle" data-toggle="dropdown">
    <span class="selected" [id]="idPrefix + '-country-select-selected'">
      {{ code }}
    </span>
  </div>

  <ul class="options dropdown-menu" [id]="idPrefix + '-country-select-options'">
    <li *ngFor="let code of codes"
        [id]="idPrefix + '-country-select-' + code"
        class="dropdown-item"
        (click)="setCode(code)">{{ code }}
    </li>
  </ul>

</section>
